<script setup lang="ts">
import LabelBase from '@/components/label/LabelBase.vue'
import PhIcon from '@/components/PhIcon.vue'
import type { ColorKey } from '@/types/tailwind'
import { bgColor500p25, textColor500 } from '@/globals/tailwind.ts'

// props & emit
withDefaults(
  defineProps<{
    title: string
    desc?: string
    color?: ColorKey
    icon?: string
  }>(),
  {
    color: 'blue',
  },
)
</script>

<template>
  <div
    class="p-4 pt-6 space-y-4 border-b border-dashed border-stone-200 dark:border-stone-700 transition-colors duration-150"
  >
    <div class="mb-6">
      <label-base size="xl" class="block font-bold">{{ title }}</label-base>
      <label-base v-if="desc" color="stone" size="sm" class="block">{{ desc }}</label-base>
    </div>
    <div class="flex gap-6">
      <div v-if="icon">
        <div :class="[bgColor500p25[color], textColor500[color]]" class="p-4 rounded-2xl">
          <ph-icon :name="icon" :size="32"></ph-icon>
        </div>
      </div>
      <div class="w-full">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
